import { UserOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import Avatar from 'antd/lib/avatar/avatar';
import { getMediaStore } from 'core/modules/media/media.store';
import moment from 'moment';
import { useMemo } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TaskActivityLabel = function TaskActivityLabel(_ref) {
  var title = _ref.title,
      createdAt = _ref.createdAt,
      user = _ref.user;

  var _getMediaStore = getMediaStore(),
      media = _getMediaStore.media,
      getUserMediaSrc = _getMediaStore.getUserMediaSrc;

  return useMemo(function () {
    return /*#__PURE__*/_jsxs(Container, {
      children: [user && /*#__PURE__*/_jsx("span", {
        className: "user",
        children: /*#__PURE__*/_jsx(Tooltip, {
          title: user.name,
          children: /*#__PURE__*/_jsx(Avatar, {
            src: getUserMediaSrc(user.id),
            size: "small",
            icon: /*#__PURE__*/_jsx(UserOutlined, {})
          })
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "meta-info",
        children: [/*#__PURE__*/_jsx("span", {
          className: "title",
          children: title
        }), /*#__PURE__*/_jsx("span", {
          className: "date",
          children: moment(createdAt).fromNow()
        })]
      })]
    });
  }, [user === null || user === void 0 ? void 0 : user.id, user === null || user === void 0 ? void 0 : user.name, title, createdAt, media]);
}; // Styles

var Container = styled.div.withConfig({
  displayName: "Label__Container",
  componentId: "sc-yjpb34-0"
})(["display:flex;flex-direction:row;align-items:center;justify-content:center;text-align:right;margin-right:12px;.title{font-weight:bold;}.date{font-size:0.8em;}.user{margin-right:12px;flex:1;}.meta-info{display:flex;flex-direction:column;align-items:flex-end;justify-content:center;text-align:right;}"]);